//MADE THIS DOC FOR 2016 MVC DETAILS PAGE - MAKING VIDEO PLAYER RESPONSIVE
$(function(){
	var lastFocus;	
    
	// Allows us to create a custom HTML title to top of the dialog box
	$.widget("ui.dialog", $.extend({}, $.ui.dialog.prototype, { 
		 _title: function(title) { 
			var $title = this.options.title || '&nbsp;' 
			if( ("titleIsHtml" in this.options) && this.options.titleIsHtml == true ) 
				title.html($title); 
			else title.text($title); 
		} 
	}));
	
	$(".videoLink").on('click', function(event){
		event.preventDefault();
		lastFocus = document.activeElement;
		if($('div#videoDialog').length < 1) {
			// add an empty div within the form, then will be used by the jquery-ui dialog
			$('<div/>', { id: "videoDialog", style: "display:none;" }).appendTo('form');
		}
				
		var controllerUrl = "/video/videodetails/" + $(this).attr("data-productid");
		var vidTitle = $(this).attr("title");
		var videoUrl;		
		
		$.get(controllerUrl, function(data){
			videoUrl = data.PublishedUrl;		
			var vidMarkup = "<video id=\"azuremediaplayer\" class=\"azuremediaplayer amp-flush-skin amp-big-play-centered embed-responsive-item\" width=\"100%\" height=\"100%\" tabindex=\"0\">" + "</video>";
                	$("#videoDialog").html(vidMarkup).dialog({
	        		title: "<label for='azuremediaplayer_AzureHtml5JS_api'>" + vidTitle + "</label>",
	        		titleIsHtml: true,
				modal: true, 				
				draggable: false,
				resizable: false,
				beforeClose: function(event, ui) {					
					// azure media player nicely stops the video when the ui-dialog element is removed. that's easy
					$(".ui-dialog").remove();
					myPlayer.dispose();
					lastFocus.focus();
					$('#videoDialog').attr('aria-hidden', 'true');						
				}
	   		});
	   		$('.ui-dialog-titlebar-close').attr({
	   			'tabindex': '0',
	   			'role': 'button'
	   		 }).focus();
	   		
	   		var myPlayer = amp('azuremediaplayer', {
		        autoplay: true,
		        controls: true,
		        logo: { enabled: false },
		        techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"]
			});
			
			// Add subtitles, if available
			if(data.EnglishSubtitleUrl && data.EnglishSubtitleUrl.length > 0) {
				myPlayer.src([
				{ src: videoUrl, type: "application/vnd.ms-sstr+xml" }
				],[
		                { src: data.EnglishSubtitleUrl, srclang: "en", kind: "subtitles", label: "English" }
		            ]);
			} else {
				myPlayer.src([{ 
				    src: videoUrl, 
				    type: "application/vnd.ms-sstr+xml"
				}]);	
			}
		});
	});
	
	$(".videoLink").on('keypress', function(event){
		if(event.which == 13){
 			$(this).click();
	 	}
	});
});